export enum FILE_REF_TYPE {
  COMPANY = 'company',
  BRANCH = 'branch',
  SKU = 'sku',
}

export enum CONTACT_TYPE {
  PHONE = 'phone',
  MOBILE = 'mobile',
  CONTACT_PHONE = 'contactPhone',
  EMAIL = 'email',
  OFFICE = 'office',
}

export enum LanguageKeys {
  TH = 'th',
  EN = 'en',
}

export enum DATE_UNIT {
  DAY = 'DAY',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export enum WARRANTY_TYPE {
  PERIOD = 'period warranty',
  LIFETIME = 'lifetime warranty',
  NONE = 'no warranty',
}

export enum TASK_EVENT_TYPE {
  TASK_CREATED_BY_CUSTOMER = 'TASK_CREATED_BY_CUSTOMER',
  TASK_CREATED_BY_ADMIN = 'TASK_CREATED_BY_ADMIN',
  TASK_CREATED_BY_SYSTEM = 'TASK_CREATED_BY_SYSTEM',
  TASK_ASSIGNED = 'TASK_ASSIGNED',
  TASK_CHECKED_IN = 'TASK_CHECKEDIN',
  TASK_PENDING = 'TASK_PENDING',
  TASK_TRANSFERRING_REQUEST = 'TASK_TRANSFERRING_REQUEST',
  TASK_PRODUCT_COMPLETED = 'TASK_PRODUCT_COMPLETED',
  TASK_COMPLETED_BY_TECHNICIAN = 'TASK_COMPLETED_BY_TECHNICIAN',
  TASK_COMPLETED_BY_ADMIN = 'TASK_COMPLETED_BY_ADMIN',
  TASK_REJECTED = 'TASK_REJECTED',
  TASK_CLOSED = 'TASK_CLOSED',
  TASK_ASSIGN_UPLOAD_BEFORE_PHOTOS = 'TASK_ASSIGN_UPLOAD_BEFORE_PHOTOS',
  TASK_ASSIGN_UPLOAD_AFTER_PHOTOS = 'TASK_ASSIGN_UPLOAD_AFTER_PHOTOS',
  TASK_PRODUCT_UPLOAD_BEFORE_PHOTOS = 'TASK_PRODUCT_UPLOAD_BEFORE_PHOTOS',
  TASK_PRODUCT_UPLOAD_AFTER_PHOTOS = 'TASK_PRODUCT_UPLOAD_AFTER_PHOTOS',
}
